export interface Category {
  slug: string;
  name: string;
  description: string;
  comicCount: number;
  image: string;
  colorClass: string;
}

export const categories: Category[] = [
  {
    slug: 'healing',
    name: '治愈',
    description: '温暖人心的故事，治愈你的每一天',
    comicCount: 1280,
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20anime%20illustration%20of%20a%20peaceful%20cottage%20interior%2C%20soft%20sunlight%20streaming%20through%20windows%2C%20plants%20and%20books%2C%20gentle%20pastel%20colors%2C%20healing%20atmosphere%2C%20slice-of-life%20aesthetic%2C%20warm%20amber%20and%20cream%20tones%2C%20comforting%20vibe%2C%20minimalist%20composition%2C%20soft%20focus&width=800&height=600&seq=cat-healing-01&orientation=landscape',
    colorClass: 'amber',
  },
  {
    slug: 'action',
    name: '热血',
    description: '燃爆的战斗场面，永不言败的精神',
    comicCount: 2150,
    image: 'https://readdy.ai/api/search-image?query=Epic%20action%20anime%20scene%20of%20warriors%20in%20battle%2C%20dynamic%20pose%2C%20energy%20effects%2C%20dramatic%20lighting%2C%20mountainous%20landscape%20background%2C%20mint%20green%20and%20gold%20color%20accents%2C%20shounen%20style%2C%20intense%20atmosphere%2C%20powerful%20composition&width=800&height=600&seq=cat-action-01&orientation=landscape',
    colorClass: 'mint',
  },
  {
    slug: 'romance',
    name: '恋爱',
    description: '甜蜜的心动瞬间，浪漫的爱情故事',
    comicCount: 1890,
    image: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20illustration%20of%20a%20couple%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20petals%20falling%2C%20golden%20hour%20sunlight%2C%20gentle%20expressions%2C%20dreamy%20atmosphere%2C%20shoujo%20manga%20style%2C%20pastel%20rose%20and%20cream%20tones%2C%20sweet%20romantic%20vibe&width=800&height=600&seq=cat-romance-01&orientation=landscape',
    colorClass: 'rose',
  },
  {
    slug: 'mystery',
    name: '悬疑',
    description: '扣人心弦的谜题，烧脑刺激的推理',
    comicCount: 960,
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20scene%20of%20a%20detective%20office%20at%20night%2C%20clues%20and%20photos%20on%20a%20cork%20board%2C%20dim%20warm%20lamp%20lighting%2C%20rain%20outside%20window%2C%20noir%20atmosphere%2C%20cool%20gray%20and%20amber%20tones%2C%20suspenseful%20composition%2C%20seinen%20style&width=800&height=600&seq=cat-mystery-01&orientation=landscape',
    colorClass: 'gray',
  },
];

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}